#show-if-priority,
#hide-if-priority {
  display: none;
}
